import React, { useState } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { Check, ChevronDown } from 'styled-icons/fa-solid';

import { useLanguageSelect } from './useLanguageSelect';

import * as S from './styles';

export const LanguageSelect = () => {
  const { t, i18n } = useTranslation('common');

  const { changeLanguage } = useLanguageSelect();

  const [isOpen, setIsOpen] = useState(false);

  function handleOpen() {
    setIsOpen((current) => !current);
  }

  async function handleClick(language: 'it' | 'en') {
    await changeLanguage(language);

    setIsOpen(false);
  }

  return (
    <>
      <S.Wrapper>
        <S.Picker onClick={handleOpen}>
          <S.Flag>
            {i18n.language === 'it' ? (
              <Image
                src="/images/flags/it_italy.svg"
                width={16}
                height={16}
                alt="Italiano (IT)"
              />
            ) : (
              <Image
                src="/images/flags/gb_ukm_united_kingdom.svg"
                width={16}
                height={16}
                alt="Inglese (EN)"
              />
            )}
          </S.Flag>

          {i18n.language}

          <S.Icon $isOpen={isOpen}>
            <ChevronDown />
          </S.Icon>
        </S.Picker>

        <S.ListWrapper $isOpen={isOpen}>
          <S.Label>{t('global.language-select')}</S.Label>

          <S.List>
            <S.Item
              onClick={() => handleClick('it')}
              $isSelected={i18n.language === 'it'}
            >
              <S.Flag>
                <Image
                  src="/images/flags/it_italy.svg"
                  width={20}
                  height={20}
                  alt="Italiano (IT)"
                />
              </S.Flag>

              <>Italiano (IT)</>

              <S.Icon>
                <Check />
              </S.Icon>
            </S.Item>

            <S.Item
              onClick={() => handleClick('en')}
              $isSelected={i18n.language === 'en'}
            >
              <S.Flag>
                <Image
                  src="/images/flags/gb_ukm_united_kingdom.svg"
                  width={20}
                  height={20}
                  alt="Inglese (EN)"
                />
              </S.Flag>

              <>Inglese (EN)</>

              <S.Icon>
                <Check />
              </S.Icon>
            </S.Item>
          </S.List>
        </S.ListWrapper>
      </S.Wrapper>

      {isOpen && <S.Overlay onClick={handleOpen} />}
    </>
  );
};
